// extracted by mini-css-extract-plugin
module.exports = {"title":"title___3IHCm","featuredAuthor":"featuredAuthor___2zJlM"};